import React, { useEffect, useState } from "react";
import {
  Badge,
  Card,
  CardBody,
  CardHeader,
  Col,
  Container,
  Nav,
  NavItem,
  NavLink,
  Row,
  TabContent,
  TabPane,
} from "reactstrap";
import classnames from "classnames";
import { Link, useNavigate, useParams } from "react-router-dom";

//import images
import slack from "../../../assets/images/brands/slack.png";
import BlogService from "../../../services/KangarooServices/BlogService";
import BreadCrumb from "../../../Components/Common/BreadCrumb";
import { Calendar, Clock, Edit3, FileText, Globe, ImageIcon, Tag } from "lucide-react";
import { imageBaseApi } from "../../../utilis/imageHelper";
import { formatDate } from "../../../Components/Common/FormatDate";

const BlogDetail = () => {
  const [activeTab, setActiveTab] = useState("1");
  const navigate = useNavigate()
  const { id } = useParams();
  console.log(id);
  const [data, setData] = useState();

  const fetchDatabyId = async (id) => {
    const res = await BlogService.getDetail(id);
    setData(res);
  };

  useEffect(() => {
    fetchDatabyId(id);
  }, [id]);
  console.log(data);

  const getStatusColor = (status) => {
    switch (status) {
      case "Published":
        return "success";
      case "Draft":
        return "warning";
      case "Archived":
        return "secondary";
      default:
        return "light";
    }
  };

  const breadcrumbItems = [{ title: "Back to List", link: "/blog" }];
  return (
    <React.Fragment>
      <div className="page-content">
        <Container fluid>
          <BreadCrumb
            title="Blog"
            pageTitle="Details"
            breadcrumbItems={breadcrumbItems}
          />

          {/* Hero Section with Cover Image */}
          <Row>
            <Col lg={12}>
              <Card className="border-0 shadow-sm mb-4">
                <div className="position-relative bg-dark">
                  <img
                    src={`${imageBaseApi}${data?.coverMedia?.url}`}
                    alt={data?.title}
                    className="w-100 opacity-50 z-index-1"
                    style={{ height: "300px", objectFit: "cover" }}
                  />

                  {/* Title Overlay */}
                  <div className="position-absolute bottom-0 start-0 w-100 p-4 text-white" style={{height:"300px"}}>
                    <Row>
                      <Col lg={12} xl={12}>
                        <div className="d-flex justify-content-between align-items-center mb-3">
  {/* Left: Status Badge */}
  <Badge
    color={getStatusColor(data?.status)}
    className="fs-6 px-3 py-2"
  >
    {data?.status}
  </Badge>

  {/* Right: Edit Button */}
  <button
    type="button"
    className="btn btn-success btn-sm d-flex align-items-center gap-2"
    onClick={() => navigate(`/blog/update/${id}`)}
  >
    Edit Blog
  </button>
</div>

                        <h1 className="display-5 fw-bold mb-3 text-white">
                          {data?.title}
                        </h1>
                        <div className="d-flex flex-wrap gap-4">
                          <div className="d-flex align-items-center gap-2">
                            <Calendar size={18} />
                            <span className="fs-6">
                              {formatDate(data?.publishedAt)}
                            </span>
                          </div>
                          <div className="d-flex align-items-center gap-2">
                            <Clock size={18} />
                            <span className="fs-6">
                              {data?.readingTime} min read
                            </span>
                          </div>
                        </div>
                      </Col>
                    </Row>
                  </div>
                </div>
              </Card>
            </Col>
          </Row>

          {/* Main Content */}
          <Row>
            <Col lg={8}>
              {/* Short Description */}
              <Card className="border-0 shadow-sm mb-4">
                <CardHeader className="bg-transparent border-bottom py-3">
                  <h5 className="mb-0 fw-bold d-flex align-items-center gap-2 text-dark">
                    <FileText size={18} className="text-primary" />
                    Short Description
                  </h5>
                </CardHeader>
                <CardBody className="p-4">
                  <div className="border-start border-primary border-4 ps-3">
                    <p className="lead text-muted mb-0 fs-5 lh-base">
                      {data?.shortDescription}
                    </p>
                  </div>
                </CardBody>
              </Card>

              {/* Main Content */}
              <Card className="border-0 shadow-sm">
                <CardHeader className="bg-transparent border-bottom py-3">
                  <h5 className="mb-0 fw-bold d-flex align-items-center gap-2 text-dark">
                    <FileText size={18} className="text-primary" />
                    Content
                  </h5>
                </CardHeader>
                <CardBody className="p-4">
                  <div
                    className="fs-5 lh-lg text-secondary"
                    dangerouslySetInnerHTML={{ __html: data?.content }}
                  />
                </CardBody>
              </Card>
            </Col>

            {/* Sidebar */}
            <Col lg={4}>
              {/* Thumbnail Preview */}
              {data?.thumbnailMedia?.url && (
                <Card className="border-0 shadow-sm mb-4 overflow-hidden">
                  <CardHeader className="bg-transparent border-bottom py-3">
                    <h5 className="mb-0 d-flex align-items-center gap-2 text-dark">
                      <ImageIcon size={18} className="text-primary" />
                      Featured Image
                    </h5>
                  </CardHeader>
                  <CardBody className="p-0">
                    <div className="bg-light d-flex justify-content-center">
                      <img
                        src={`${imageBaseApi}${data?.thumbnailMedia?.url}`}
                        alt={data.thumbnailMedia.fileName}
                        className="img-fluid w-100"
                        style={{ maxHeight: "250px", objectFit: "contain" }}
                      />
                    </div>
                    <div className="p-3 bg-white">
                      <div className="d-flex align-items-center gap-2 text-muted small">
                        <Tag size={12} className="text-primary" />
                        <span className="text-truncate">
                          {data.thumbnailMedia.fileName}
                        </span>
                      </div>
                    </div>
                  </CardBody>
                </Card>
              )}

              {/* Blog Information */}
              <Card className="border-0  shadow-sm mb-4">
                <CardBody>
                  <h5 className="card-title border-bottom mb-2 fw-bold">
                    Blog Information
                  </h5>

                  <div className="mb-3 pb-3 border-bottom">
                    <div className="text-muted small mb-2">Status</div>
                    <Badge
                      color={getStatusColor(data?.status)}
                      className="px-3 py-2 fs-6"
                    >
                      {data?.status}
                    </Badge>
                  </div>

                  <div className="mb-3 pb-3 border-bottom">
                    <div className="text-muted small mb-2">Published Date</div>
                    <div className="fw-medium">
                      {formatDate(data?.publishedAt)}
                    </div>
                  </div>

                  <div className="mb-3 pb-3 border-bottom">
                    <div className="text-muted small mb-2">Reading Time</div>
                    <div className="fw-medium">{data?.readingTime} minutes</div>
                  </div>

                  {/* <div className="mb-3 pb-3 border-bottom">
                    <div className="text-muted small mb-2">Slug</div>
                    <div className="fw-medium text-break small">
                      {data?.slug}
                    </div>
                  </div>

                  <div>
                    <div className="text-muted small mb-2">Meta Title</div>
                    <div className="fw-medium">{data?.metaTitle}</div>
                  </div> */}
                </CardBody>
              </Card>

              {/* SEO Information */}
              <Card className="border-0 shadow-sm mb-4">
                <CardHeader className="bg-transparent border-bottom py-3">
                  <h5 className="mb-0 d-flex align-items-center gap-2 text-dark">
                    <Globe size={18} className="text-primary" />
                    SEO Information
                  </h5>
                </CardHeader>
                <CardBody>
                  {/* Meta Title */}
                  <div className="mb-3">
                    <div className="text-muted small mb-1">Meta Title</div>
                    <p className="fw-semibold mb-0">
                      {data?.metaTitle || "N/A"}
                    </p>
                  </div>

                  {/* Meta Description */}
                  <div className="mb-0">
                    <div className="text-muted small mb-1">
                      Meta Description
                    </div>
                    <p
                      className="mb-0 text-truncate"
                      style={{ maxWidth: "100%" }}
                    >
                      {data?.metaDescription || "N/A"}
                    </p>
                  </div>
                </CardBody>
              </Card>
            </Col>
          </Row>
        </Container>
      </div>
    </React.Fragment>
  );
};

export default BlogDetail;
